/* unplugin-vue-components disabled */import script from "./AssetsEChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsEChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__